<template>
  <div class="container">
    <div class="text-center py-5">
      <h1 class="h2 pt-md-5">🏔️ Горный чат <sup class="small text-primary">beta</sup></h1>
      <p>В чате обсуждаем походы, маршруты, погоду. Общаемся, знакомимся и ищем попутчиков для ваших походов.</p>
      <hr class="space space-xs">
      <loader v-show="isLoading"></loader>
      <div v-show="!isLoading" class="row clearfix">
        <div class="col-lg-12">
          <div class="card chat-app no-border">
            <div class="row">
              <div class="col-md-3">
                <div id="plist" class="people-list">
                  <!-- <p class="text-left">Выберите чат:</p>
                  <ul class="list-unstyled chat-list mt-2 mb-4 bg-light py-2">
                    <li class="clearfix" v-for="chat in sortedChats" :key="chat.id" @click="setActiveChat(chat)">
                      <div class="about">
                        <div class="name" v-if="chat && chat.title">
                          <strong v-if="chat.id == chatGroupId">{{ chat.title }}</strong>
                          <span v-else>{{ chat.title }}</span>
                        </div>
                      </div>
                    </li>
                  </ul> -->
                  <div class="card text-left small bg-cream no-border">
                    <div class="card-body">
                      <h5>Правила чата</h5>
                      <p class="mb-1">1. Не использовать мат</p>
                      <p class="mb-1">2. Не оскорблять других участников</p>
                      <p class="mb-1">3. Не писать в чате о политике</p>
                      <p class="mb-1">4. Не писать в чате о религии</p>
                      <p class="mb-1">5. Не писать в чате о футболе</p>
                      <p>6. Не допускается реклама.</p>
                      <p class="mb-1"><strong>За нарушение любого из этих правил и проявление агрессии - БАН!</strong></p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-9">

                <div class="chat border">
                  <div class="chat-header clearfix">
                    <div class="row">
                      <div class="col-md-12 d-flex align-items-center">
                        <router-link :to="{ name: 'public-profile', params: { id: user.id } }">
                          <img v-if="user.photoUrl" class="img-fluid rounded-circle mr-2" width="30" :src="user.photoUrl" alt="">
                          <img v-else-if="user.name" class="img-fluid rounded-circle mr-2" width="30" :src="`https://ui-avatars.com/api/?name=${user.name.charAt(0)}&size=30&rounded=true`" alt="">
                          <img v-else-if="user.firstName" class="img-fluid rounded-circle mr-2" width="30" :src="`https://ui-avatars.com/api/?name=${user.firstName.charAt(0)}&size=30&rounded=true`" alt="">
                        </router-link>
                        <div class="chat-about">
                          <h6 class="mb-0"><strong>{{ user.name }}</strong> в чате <strong v-if="chat && chat.title">{{ chat.title }}</strong>.</h6>
                        </div>
                      </div>
                      <!-- <div class="col-lg-6 hidden-sm text-right">
                          <a href="javascript:void(0);" class="btn btn-outline-secondary"><i class="fa fa-camera"></i></a>
                          <a href="javascript:void(0);" class="btn btn-outline-primary"><i class="fa fa-image"></i></a>
                          <a href="javascript:void(0);" class="btn btn-outline-info"><i class="fa fa-cogs"></i></a>
                          <a href="javascript:void(0);" class="btn btn-outline-warning"><i class="fa fa-question"></i></a>
                      </div> -->
                    </div>
                  </div>
                  <div class="chat-history" ref="chatContainer">
                    <ul class="m-b-0">
                      <li class="clearfix" v-for="message in sortedMessages" :key="message.id">
                        <div class="message-data" :class="{'text-right': user.id === message.senderId, 'text-left': user.id !== message.senderId}">
                          <span class="message-data-time small">
                            {{ formatTimestamp(message.timestamp) }}
                          </span>
                          <router-link class="text-dark" :to="{ name: 'public-profile', params: { id: message.senderId } }">
                            <img v-if="message.senderId == 'o7b92fHYgtTbTallR5EBcMnMB9J2' || message.senderId == 'EmMEIyQJeUc4ww4qliefyFuBhFq1'" class="img-fluid rounded-circle mr-2" width="30" src="https://zabugorshiki.com/wp-content/themes/understrap-child/images/logo_xs.jpg" alt="">
                            <img v-else-if="message.senderPictureUrl" class="img-fluid rounded-circle mr-2" width="30" :src="message.senderPictureUrl" alt="">
                            <img v-else-if="message.senderName" class="img-fluid rounded-circle mr-2" width="30" :src="`https://ui-avatars.com/api/?name=${message.senderName.charAt(0)}&size=30&rounded=true`" alt="">
                            <img v-else-if="message.firstName" class="img-fluid rounded-circle mr-2" width="30" :src="`https://ui-avatars.com/api/?name=${message.firstName.charAt(0)}&size=30&rounded=true`" alt="">
                            <strong v-if="message.senderId == 'o7b92fHYgtTbTallR5EBcMnMB9J2'">ЗАБУГОРЩИКИ (Ренат)</strong>
                            <strong v-else-if="message.senderId == 'EmMEIyQJeUc4ww4qliefyFuBhFq1'">Руслан</strong>
                            <strong v-else-if="message.senderId == 'EhGDbosJXaW8Jr0niYrlJSVVWUd2'">Амина</strong>
                            <span v-else>{{ message.senderName }}</span>
                          </router-link>
                          <div v-if="user.id === message.senderId || user.isAdmin" class="float-right ml-2">
                            <button @click="deleteMessage(message.id)" class="btn btn-light btn-sm">x</button>
                          </div>
                        </div>
                        <div class="message other-message" :class="{'float-right ml-md-5': user.id === message.senderId, 'float-left mr-md-5': user.id !== message.senderId}">
                          <div v-if="message.replyTo" class="d-block text-left">
                            <small class="badge badge-light smaller text-left" style="white-space: break-spaces" v-if="findMessageById(message.replyTo)">Ответ: {{ findMessageById(message.replyTo).message }}</small>
                          </div>
                          {{ message.message }} 
                          <button v-if="user.id !== message.senderId" class="btn btn-light btn-sm" @click="replyToMessage(message.id)">Ответить</button>
                          <div class="message-actions" v-if="message.likes">
                            <button class="btn btn-light btn-sm" :class="{ 'liked': isLiked(message.id) }" @click="toggleLike(message.id)">
                              <span class="like-icon" v-if="isLiked(message.id)">
                                <span v-for="like in message.likes" :key="like">🏔️</span>
                              </span>
                              <span class="like-icon" v-else-if="message.likes && message.likes.length > 0">
                                <span v-for="like in message.likes" :key="like">🏔️</span>
                              </span>
                              <span class="like-icon" v-else>🤍</span>
                            </button>
                          </div>
                        </div>
                        
                      </li>
                    </ul>
                  </div>
                  <div class="chat-message clearfix">
                    <form @submit.prevent="sendMessage">
                      <div v-if="replyTo" class="mb-2 text-left">
                        <small class="badge badge-warning">Ответ: {{ findMessageById(replyTo).message }}</small>
                        <button class="btn btn-light btn-sm" @click="cancelReply">Отменить</button>
                      </div>
                      <div class="input-group">
                        <input v-model="newMessage" type="text" class="form-control" placeholder="Введите сообщение">
                        <div class="input-group-append">
                          <button class="btn btn-primary btn-sm" type="submit">Отправить</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'chat',
  components: {},
  data () {
    return {
      newMessage: '',
      chatGroupId: 'f6cFVPDApgqhzHGi4Y5u',
      badWords: ['badword1', 'badword2', 'badword3'],
      replyTo: null,
      isLoading: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      messages: state => state.chat.messages,
      chats: state => state.chat.chats,
      chat: state => state.chat.chat,
      userCount: state => state.auth.userCount
    }),
    sortedMessages () {
      return this.messages.sort((a, b) => {
        return a.timestamp.seconds - b.timestamp.seconds
      })
    },
    sortedChats () {
      const sortedChats = [...this.chats]
      const firstChat = sortedChats.find(chat => chat.id === 'f6cFVPDApgqhzHGi4Y5u')
      if (firstChat) {
        sortedChats.splice(sortedChats.indexOf(firstChat), 1)
        sortedChats.unshift(firstChat)
      }
      return sortedChats
    }
  },
  methods: {
    toggleLike (messageId) {
      this.$store.dispatch('LIKE_MESSAGE', messageId)
    },
    isLiked (messageId) {
      const message = this.findMessageById(messageId)
      if (message && message.likes) {
        return message.likes.includes(this.user.id)
      }
      return false
    },
    setActiveChat (chat) {
      this.chatGroupId = chat.id
    },
    replyToMessage (messageId) {
      this.replyTo = messageId
    },
    cancelReply () {
      this.replyTo = null
    },
    filterBadWords (message) {
      let filteredMessage = message
      this.badWords.forEach(word => {
        const regex = new RegExp(word, 'gi')
        filteredMessage = filteredMessage.replace(regex, '*'.repeat(word.length))
      })
      return filteredMessage
    },
    formatTimestamp (timestamp) {
      const date = timestamp.toDate()
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      return `${day}.${month} ${hours}:${minutes}`
    },
    async sendMessage () {
      if (this.newMessage.trim() !== '') {
        try {
          const message = {
            chatGroupId: this.chatGroupId,
            message: this.newMessage,
            senderId: this.user.id,
            senderName: this.user.name ? this.user.name : this.user.firstName,
            senderPictureUrl: this.user.photoUrl ? this.user.photoUrl : null,
            timestamp: new Date(),
            replyTo: this.replyTo,
            likes: []
          }
          await this.$store.dispatch('SEND_MESSAGE', message)
          this.newMessage = ''
          this.replyTo = null
        } catch (error) {
          console.error('Error sending message:', error)
        }
        this.scrollToBottom()
      }
    },
    findMessageById (messageId) {
      return this.messages.find(message => message.id === messageId)
    },
    async deleteMessage (messageId) {
      try {
        await this.$store.dispatch('DELETE_MESSAGE', messageId)
      } catch (error) {
        console.error('Error deleting message:', error)
      }
    },
    scrollToBottom () {
      this.$nextTick(() => {
        this.$refs.chatContainer.scrollTop = this.$refs.chatContainer.scrollHeight
      })
    }
  },
  async mounted () {
    try {
      this.isLoading = true
      await this.$store.dispatch('GET_USER')
      await this.$store.dispatch('GET_ALL_CHATS')
      await this.$store.dispatch('GET_CHAT', this.chatGroupId)
      await this.$store.dispatch('GET_MESSAGES', this.chatGroupId)
      this.isLoading = false
    } catch (error) {
      console.error('Error fetching chat or messages:', error)
    }
    this.scrollToBottom()
  },
  watch: {
    messages () {
      this.scrollToBottom()
    },
    async chatGroupId () {
      await this.$store.dispatch('GET_CHAT', this.chatGroupId)
      await this.$store.dispatch('GET_MESSAGES', this.chatGroupId)
      this.scrollToBottom()
    }
  }
}
</script>

<style scoped>
.chat-area {
  max-height: 300px;
}

.chat-messages {
  max-height: 200px;
}
</style>
